import React, { useState, useEffect } from "react";
import Modal1 from "../modals/Modal1";
import PrimaryButton from "../buttons/PrimaryButton";
import SecondaryButton from "../buttons/SecondaryButton";
import CheckBoxGrey from "../textfields/CheckBoxGrey";
import { getArrayDocDataByID } from "../models/DataFunctions";
import SmallSpinner from "../loading/SmallSpinner";

const PartnerSelectionModal = ({ isOpen, onClose, folder, onConfirm, loading: loadingCarnet }) => {
  const [partners, setPartners] = useState([]);
  const [selectedPartnerIds, setSelectedPartnerIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPartners = async () => {
      if (isOpen && folder?.visions && folder.visions.length > 0) {
        setLoading(true);
        try {
          // Extract org_ids from visions, excluding the master and particulier
          const partnerOrgIds = folder.visions
            .map(vision => vision.org_id)
            .filter(orgId => orgId !== folder.master_id && orgId !== "particulier");

          if (partnerOrgIds.length > 0) {
            const partnerData = await getArrayDocDataByID("org", partnerOrgIds);
            setPartners(partnerData);
            // By default, all partners are selected
            setSelectedPartnerIds(partnerOrgIds);
          } else {
            setPartners([]);
            setSelectedPartnerIds([]);
          }
        } catch (error) {
          console.error("Error loading partners:", error);
          setPartners([]);
        } finally {
          setLoading(false);
        }
      }
    };

    loadPartners();
  }, [isOpen, folder]);

  const handleTogglePartner = (partnerId) => {
    setSelectedPartnerIds((prev) => {
      if (prev.includes(partnerId)) {
        return prev.filter((id) => id !== partnerId);
      } else {
        return [...prev, partnerId];
      }
    });
  };

  const handleConfirm = () => {
    onConfirm(selectedPartnerIds);
  };

  return (
    <Modal1 isOpen={isOpen} onClose={onClose}>
      <div className="bg-white rounded-xl w-fit max-w-full h-fit max-h-[80vh] flex flex-col">
        <div className="text-h2 text-shadow_50 border-b-1 p-4 flex-shrink-0">
          Sélectionner les partenaires
        </div>
        <div className="flex flex-col gap-4 w-c400 p-4 overflow-auto flex-1">
          {loading ? (
            <div className="text-h4 text-shadow_50">Chargement...</div>
          ) : partners.length > 0 ? (
            <>
              <div className="text-h4 text-shadow_50 mb-2">
                Sélectionnez les partenaires qui auront accès au carnet :
              </div>
              {partners.map((partner) => (
                <div key={partner.id} className="flex flex-row items-center gap-2">
                  <CheckBoxGrey
                    checked={selectedPartnerIds.includes(partner.id)}
                    onChange={(checked) => handleTogglePartner(partner.id)}
                  />
                  <div className="text-h4 text-shadow_75">
                    {partner.name || "Partenaire sans nom"}
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="text-h4 text-shadow_50">
              Aucun partenaire trouvé pour ce dossier
            </div>
          )}
        </div>
        <div className="flex flex-row justify-end gap-2 p-4 border-t-1 flex-shrink-0">
          <SecondaryButton onClick={onClose} disabled={loadingCarnet}>
            Annuler
          </SecondaryButton>
          <PrimaryButton onClick={handleConfirm} disabled={loading || loadingCarnet}>
            Confirmer ({selectedPartnerIds.length} partenaire
            {selectedPartnerIds.length > 1 ? "s" : ""} sélectionné
            {selectedPartnerIds.length > 1 ? "s" : ""})
            {loadingCarnet && <SmallSpinner loading={loadingCarnet} />}
          </PrimaryButton>
        </div>
      </div>
    </Modal1>
  );
};

export default PartnerSelectionModal;
